export const configurazioneFilterDataInitialState = {
  data: {
    numeriSpecialiList: [],
    serviziFilterList: [],
    tagsList: [],
  },
  loading: false,
};

export const currentConfigurazioneInitialState = {
  data: {
    numero: "",
    ultimoAggiornamento: "",
    stato: {},
    bloccoChiamate: false,
    nngType: "",
    associazioneTreeObjectPrincipale: {},
    associazioneTreeObjectSecondario: {},
    occupato: {},
    congestione: {},
    nessunaRisposta: {},
    numeroMassimoChiamate: {},
    chiamateBloccato: {},
    areaDiOrigine: {},
    fasciaOraria: {},
    regoleDiLimitazioneList: [],
    tagsList: [],
  },
  loading: false,
};

export const currentConfigurazioneFormDataInitialState = {
  data: {
    numeriSpecialiList: [],
    statoAttualeList: [],
    destinationTypes: [],
    fdnList: [],
    fdnGroupList: [],
    odrList: [],
    tdrList: [],
    barringList: [],
    vocalMessagesList: [],
    messagiVocaliSuBaseOrigineList: [],
    whiteList: [],
    menuServiceList: [],
    nedList: [],
    fileAudioList: [],
  },
  loading: false,
};

export const treeObjectInitialState = {
  data: {
    pianoDiInstradamento: {},
    destinazione: {},
    regoleDiApplicazione: {},
  },
  loading: false,
};

export const duplicateConfigurazioneInitialState = {
  data: [],
  loading: false,
};
